<!-- AG Grid Angular Component -->
<ag-grid-angular
    [id]="feature"
    [cacheBlockSize]="cacheBlockSize"
    [suppressServerSideFullWidthLoadingRow]="true"
    [suppressAnimationFrame]="rowModelType === 'serverSide'"
    [rowBuffer]="rowBuffer"
    [maxBlocksInCache]="maxBlocksInCache"

    [rowClassRules]="rowClassRules"
    class="ag-theme-material tw-h-full tw-w-full"

    [columnMenu]="columnMenu"
    [isRowSelectable]="isRowSelectable"
    [rowModelType]="rowModelType"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [rowData]="rowModelType === 'clientSide' ? ((tableData.rowData$ | async) || [null]) : undefined"
    [rowSelection]="'multiple'"
    [suppressRowClickSelection]="true"
    (rowClicked)="onRowOrExternalClicked($event)"
    [animateRows]="true"
    [getRowId]="getRowId"
    [sideBar]="sideBar"
    [statusBar]="statusBar"
    [context]="context"
    [suppressDragLeaveHidesColumns]="true"
    [suppressColumnMoveAnimation]="true"
    [excelStyles]="excelStyles"
    (gridReady)="onGridReady($event)"
    (selectionChanged)="selectionChanged($event)"
    [localeText]="$any(localText)"
    (columnMoved)="onColumnMoved($event)"
    (columnVisible)="onColumnVisible($event)"
    (sortChanged)="onColumnSortChanged($event)"
    (columnResized)="onColumnResized($event)"
    (toolPanelVisibleChanged)="onToolPanelVisible($event)"

    [overlayNoRowsTemplate]="overlayNoRowsTemplate"
    [suppressNoRowsOverlay]="suppressNoRowsOverlay"
    [initialState]="initialState"
    (modelUpdated)="onModelUpdated($event)"
    (firstDataRendered)="onFirstDataRendered($event)"
    (filterChanged)="onFilterChanged($event)"
    [getRowClass]="getRowClass"
    (columnHeaderClicked)="onColumnHeaderClicked($event)"
    [suppressMovableColumns]="true"
    (cellValueChanged)="onCellValueChanged($event)"

    [masterDetail]="masterDetail"
    [detailCellRenderer]="'agDetailCellRenderer'"
    [detailRowAutoHeight]="detailRowAutoHeight"
    [getRowHeight]="getRowHeight"
    (rowGroupOpened)="rowGroupOpened.emit($event)"
    [detailCellRendererParams]="detailCellRendererParams"
></ag-grid-angular>
